// extracted by mini-css-extract-plugin
export var card = "_kx-5";
export var cardSelected = "_kx-4";
export var image = "_kx-3";
export var modal = "_kx-0";
export var modalContent = "_kx-1";
export var table = "_kx-2";